export const errorMsgMap = {
  "UW Policy holder Age Referred": "UW Policy holder Age Referred",
  "Number of Claim at Fault 2 Referred": "Number of Claim at Fault 2 Referred",
  "UW Make & Model Referred": "UW Make & Model Referred",
  "Error in IDNo1 or IDNo2 or ID not matches":
    "Error in IDNo1 or IDNo2 or ID not matches",
  "POLICY SHOULD BE LESS THAN 60 DAYS TO TAKE THE EARLIER POLICY":
    "POLICY SHOULD BE LESS THAN 60 DAYS",
  "SUM INSURED IS 0": "SUM INSURED IS 0",
  "REQUEST LIMIT EXCEEDED": "REQUEST LIMIT EXCEEDED",
};

export const getErrorMsg = async (error = []) => {
  let errorDesc;
  if (typeof error == "string") {
    errorDesc = error;
  } else {
    errorDesc = error.length
      ? error.map((desc) => desc.ERROR_DESC).join(",")
      : "";
  }

  const foundKey = Object.keys(errorMsgMap).find((key) =>
    errorDesc.includes(key),
  );

  return foundKey ? errorMsgMap[foundKey] : "general";
};
